import { createFileRoute, Outlet } from '@tanstack/react-router';

import { useWorkspace } from '@/app/context';
import { filterNav, PROJECT_NAV } from '@/app/navigation';
import { RouteTabs } from '@/components/common/route-tabs';
import { useT } from '@/i18n/react';

export const Route = createFileRoute('/_app/projects/$projectId/design')({
  component: SectionLayout,
});

function SectionLayout() {
  const t = useT();
  const { projectId } = Route.useParams();
  const { nav } = useWorkspace();
  const section = filterNav(PROJECT_NAV, nav).find((item) => item.id === 'project.design');
  return (
    <>
      <RouteTabs
        items={section?.children ?? []}
        params={{ projectId }}
        label={t('Design sections')}
        variant="pills"
      />
      <Outlet />
    </>
  );
}
